export const CHANGE_NEW_PATIENT = '@@NewExistingRadio/CHANGE_NEW_PATIENT';

export const NewExistingRadioActions = {
    CHANGE_NEW_PATIENT,
};

export const selectPatientStatus = value => ({
    type: NewExistingRadioActions.CHANGE_NEW_PATIENT,
    isNewPatient: (value === 'new-patient'),
});
